import Backbone from 'backbone'
import _ from 'lodash'
import template from './text-widget.hbs'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import prepareRichText from 'scoreboard/components/rich-text/prepare-rich-text'

const TextWidget = Backbone.View.extend({

	tagName: 'li',

	className: 'text-widget',

	/**
	 * The view for text widgets
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Form} options.model the form
	 *
	 * @param {FormWidget} options.widget the widget's data
	 */
	initialize: function(options = {}) {
		this.options = options
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		return this
	},

	context: function() {
		return { message: prepareRichText(this.options.widget.html) }
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips], 'remove')
	}

})

export default TextWidget
TextWidget.__filename__ = 'forms/widgets/text-widget.js'
